<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },

    name: {
      type: String,
      required: true
    },

    label: {
      type: String,
      required: false,
      default: null
    },

    type: {
      type: String,
      required: false,
      default: 'text'
    },

    value: {
      type: String,
      required: false,
      default: ''
    },

    inputClass: {
      type: String,
      required: false,
      default: null
    },

    errors: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  emits: ['input-event', 'focus-event']
};
</script>

<template>
  <div class="w-100">
    <label
      v-if="label"
      :for="id"
      class="text-nowrap"
    >
      {{ label }}
    </label>
    <input
      :id="id"
      ref="input"
      :name="name"
      :type="type"
      :value="value"
      :class="inputClass"
      @input="$emit('input-event', $event)"
      @focus="$emit('focus-event', $event)"
    >
    <div
      v-if="errors"
      class="c-form__error"
    >
      {{ errors.join() }}
    </div>
  </div>
</template>
